import Constants from '../constants.js'
import AuthUtil from '../authUtil'
import FirestoreUtil from '../firestoreUtil'

import axios from 'axios'

import { query, orderBy, limit, collection, doc, where } from 'firebase/firestore';

export default {
  decisionAssistantRef (decisionId, decisionType) {
    // console.log(`collection path for decision type ${decisionType}: ${Constants.ASSISTANT_MESSAGE_COLLECTIONS.decisions[decisionType]}/${decisionId}`)
    return doc(FirestoreUtil.db, Constants.ASSISTANT_MESSAGE_COLLECTIONS.decisions[decisionType], decisionId)
  },
  decisionMessagesRef (decisionId, decisionType, docLimit) {
    // let ref = firebase.firestore().collection("decisions").doc(decisionId).collection("researchDocuments")
    // return ref.limit(pageSize)
    // return query(collection(FirestoreUtil.db, `decisions/${decisionId}/decisionComments`), orderBy("createdAt", "desc"), limit(docLimit))
    const decisionMesssagesCollections = Constants.ASSISTANT_MESSAGE_COLLECTIONS.decisions
    // console.log(`decisionMessagesRef collection path for decision type ${decisionType}: ${decisionMesssagesCollections[decisionType]}/${decisionId}/messages`)
    return query(collection(FirestoreUtil.db, `${decisionMesssagesCollections[decisionType]}/${decisionId}/messages`), orderBy("seq", "desc"), limit(docLimit))
  },
  assistantSuggestedActionsRef (userId, conversationId, docLimit = 20) {
    return query(collection(FirestoreUtil.db, `users/${userId}/assistant-action-suggestions`), where("conversationId", "==", conversationId), orderBy("createdAt", "desc"), limit(docLimit))
  },
  // async decisionMessagesMigrate (decisionId) {
  //   const token = await AuthUtil.getCurrenUserIdToken()
  //   const appCheckToken = await AuthUtil.getAppCheckToken()
  //   const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/messages`

  //   const res = await axios.get(assistantChatURL, {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}`,
  //       'X-Firebase-AppCheck': appCheckToken
  //     }
  //   })
  //   if (res && res.status === 200 && res.data) {
  //     return res.data
  //   } else {
  //     return null
  //   }
  // },
  async migrateLegacyCommentsToMRSChat (decisionId, decisionType, optionNames) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/migratechats`

    const payload = {
      decisionType: decisionType,
      optionNames: optionNames
    }

    const res = await axios.post(assistantChatURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async getDecisionChatMessage (decisionId, messageId) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/chat/${messageId}`

    const res = await axios.get(assistantChatURL, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async deleteDecisionChat (decisionId) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/chat`

    const res = await axios.delete(assistantChatURL, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async deleteChatFromSequence (decisionId, sequenceNumber) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/messages?after=${sequenceNumber}`

    const res = await axios.delete(assistantChatURL, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async decisionChat (decisionId, message, userName, optionNames, askingPikle = false, metadata = {}, model = null) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/chat`

    const payload = {
      message: message,
      userName: userName
    }
    if (optionNames && optionNames.length > 0) {
      payload.optionNames = optionNames
    }
    if (askingPikle) {
      payload.askingPikle = true
    }
    if (model) {
      payload.model = model
    }
    if (metadata && Object.keys(metadata).length > 0) {
      payload.metadata = metadata
    }

    const res = await axios.post(assistantChatURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async updateDecisionChatModel (decisionId, model) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const updateModelURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/chatmodel`

    const payload = {
      model: model
    }

    const res = await axios.post(updateModelURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async updateAutoApplyActions (decisionId, autoApplyActions) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const updateAutoApplyActionsURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/autoapplyactions`

    const payload = {
      value: autoApplyActions
    }

    const res = await axios.post(updateAutoApplyActionsURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async optionChat (decisionId, optionId, message, userName, optionNames) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/options/${optionId}/chat`

    const payload = {
      message: message,
      userName: userName
    }
    if (optionNames && optionNames.length > 0) {
      payload.optionNames = optionNames
    }

    const res = await axios.post(assistantChatURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async decisionFeatureSuggestions (decisionId) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/featuresuggestions`

    const res = await axios.post(assistantChatURL, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async optionFeatureValueSuggestions (decisionId, optionId, criteria) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/${decisionId}/options/${optionId}/valuesuggestions`

    const res = await axios.post(assistantChatURL, {criteria: criteria}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  gettingStartedAssistantRef (userId) {
    return doc(FirestoreUtil.db, Constants.ASSISTANT_MESSAGE_COLLECTIONS.gettingStarted, userId)
  },
  gettingStartedMessagesRef (userId, docLimit = 20) {
    return query(collection(FirestoreUtil.db, `${Constants.ASSISTANT_MESSAGE_COLLECTIONS.gettingStarted}/${userId}/messages`), orderBy("seq", "desc"), limit(docLimit))
  },
  async getStartedChat (messagePayload) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/getstarted/chat`

    const payload = {
      message: messagePayload.message
    }
    if (messagePayload.taxonOptions && messagePayload.taxonOptions.length > 0) {
      payload.taxons = messagePayload.taxonOptions
    }
    if (messagePayload.decision && messagePayload.decision.name && messagePayload.decision.id) {
      payload.decision = messagePayload.decision
    }

    const res = await axios.post(assistantChatURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async getStartedChatMessage (decisionId, messageId) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/getstarted/chat/${messageId}`

    const res = await axios.get(assistantChatURL, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  // async getStartedChatMessages () {
  //   const token = await AuthUtil.getCurrenUserIdToken()
  //   const appCheckToken = await AuthUtil.getAppCheckToken()
  //   const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/getstarted/chat`

  //   const res = await axios.get(assistantChatURL, {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}`,
  //       'X-Firebase-AppCheck': appCheckToken
  //     }
  //   })
  //   if (res && res.status === 200 && res.data) {
  //     return res.data
  //   } else {
  //     return null
  //   }
  // },
  async deleteGetStartedChat () {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const assistantChatURL = `${Constants.ASSISTANT_API_BASE_PATH}/getstarted/chat`

    const res = await axios.delete(assistantChatURL, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async suggestionResponse (suggestionID, isAccepted, categoryData, taxonRegion, scraperRegion) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const suggestedDecisionURL = `${Constants.ASSISTANT_API_BASE_PATH}/decisions/suggested/${suggestionID}`

    const payload = {
      userApproved: isAccepted,
      taxonRegion: taxonRegion,
      categoryData: categoryData
    }

    if (scraperRegion) {
      payload.scraperRegion = scraperRegion
    }

    const res = await axios.post(suggestedDecisionURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  },
  async suggestedActionResponse (suggestionID, isAccepted, additionalData) {
    const token = await AuthUtil.getCurrenUserIdToken()
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const suggestedDecisionURL = `${Constants.ASSISTANT_API_BASE_PATH}/actions/${suggestionID}`

    const payload = {
      userApproved: isAccepted,
      additionalData: additionalData || {}
    }

    // if (scraperRegion) {
    //   payload.scraperRegion = scraperRegion
    // }

    const res = await axios.post(suggestedDecisionURL, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Firebase-AppCheck': appCheckToken
      }
    })
    if (res && res.status === 200 && res.data) {
      return res.data
    } else {
      return null
    }
  }
}
